module.exports = __webpack_public_path__ + "static/img/bg-en.c67ac186.png";